<script>
import ViewGeneral from '@/views/Analytics/General/ViewGeneral'
import StatisticService from '@/services/statistic.service'
import moment from 'moment'
import ApiService from '@/services/apis.service'
import _ from 'lodash'

export default {
    name: 'ApiGeneral',
    extends: ViewGeneral,
    computed: {
        title () {
            return this.$t('api')
        }
    },
    methods: {
        update () {
            if (!this.validateForm()) {
                return
            }
            StatisticService.getActiveApiStatistic(this.timeSeries).then(
                result => {
                    let labels = []
                    let timeSeries = result.data.time_series
                    for (let i = 0; i < timeSeries.length - 1; i++) {
                        labels.push(moment(timeSeries[i]).format(this.timeFormat))
                    }
                    this.total = _.sum(result.data.apis.map(api => _.sum(api.count)))
                    this.data = result.data.apis
                    this.labels = labels
                    this.renderChartUser()
                }
            )
        },
        getDatasets () {
            let chart = this.$refs.lineChart.$data._chart
            let datasets = []
            for (let item of this.data) {
                datasets.push({
                    label: item.name,
                    data: item.count,
                    backgroundColor: ApiService.getApiColor(item.api_code),
                    borderColor: ApiService.getApiColor(item.api_code),
                    fill: false,
                    hidden: chart ? !chart.isDatasetVisible(0) : false
                })
            }
            return datasets
        }
    }
}
</script>
